import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500/75 transition-opacity" }, null, -1)
const _hoisted_2 = { class: "fixed inset-0 overflow-y-auto" }
const _hoisted_3 = { class: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0" }
const _hoisted_4 = { class: "sm:flex sm:items-start" }
const _hoisted_5 = { class: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left" }
const _hoisted_6 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_7 = { class: "text-sm text-gray-500" }
const _hoisted_8 = { class: "mt-5 sm:mt-4 sm:flex sm:flex-row-reverse" }

import { Dialog, DialogPanel, TransitionChild, TransitionRoot, DialogTitle } from "@headlessui/vue";
import { ExclamationTriangleIcon } from "@heroicons/vue/24/outline";
import { computed, ref, watch } from "vue";
import { useStore } from "vuex";
import { ConfirmationModalArgs } from "@/types/modals";


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmationModal',
  setup(__props) {

const store = useStore();
const confirmationModalArgs = computed(() => store.state.confirmationModal?.args);
const confirmationModalArgsWithDelayedClear = ref<ConfirmationModalArgs | null>(null);

const setConfirm = (confirmed: boolean) => {
  store.commit("setConfirmationModalConfirmed", confirmed);
};

const colors = computed(() => {
  const colorsPresets = {
    red: {
      bgLight: "bg-red-100",
      bgMedium: "bg-red-500",
      bgDark: "bg-red-600",
      bgHover: "hover:bg-red-600",
      ringFocus: "focus:ring-red-600",
      text: "text-red-600",
    },
    yellow: {
      bgLight: "bg-yellow-100",
      bgMedium: "bg-yellow-500",
      bgDark: "bg-yellow-600",
      bgHover: "hover:bg-yellow-600",
      ringFocus: "focus:ring-yellow-600",
      text: "text-yellow-600",
    },
  };

  if (!confirmationModalArgsWithDelayedClear.value?.color) {
    return colorsPresets.yellow;
  }

  return colorsPresets[confirmationModalArgsWithDelayedClear.value.color];
});

watch(
  () => confirmationModalArgs.value,
  () => {
    if (confirmationModalArgs.value) {
      confirmationModalArgsWithDelayedClear.value = confirmationModalArgs.value;
    } else {
      setTimeout(() => {
        confirmationModalArgsWithDelayedClear.value = null;
      }, 300);
    }
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    as: "template",
    show: !!confirmationModalArgs.value
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        class: "relative",
        style: {"z-index":"999999"},
        onClose: _cache[2] || (_cache[2] = ($event: any) => (setConfirm(false)))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TransitionChild), {
            as: "template",
            enter: "ease-out duration-300",
            "enter-from": "opacity-0",
            "enter-to": "opacity-100",
            leave: "ease-in duration-200",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogPanel), { class: "relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6" }, {
                    default: _withCtx(() => [
                      (confirmationModalArgsWithDelayedClear.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("div", _hoisted_4, [
                              _createElementVNode("div", {
                                class: _normalizeClass([
                      'mx-auto flex h-12 w-12 shrink-0 items-center justify-center rounded-full sm:mx-0 sm:h-10 sm:w-10',
                      colors.value.bgLight,
                    ])
                              }, [
                                _createVNode(_unref(ExclamationTriangleIcon), {
                                  class: _normalizeClass(['h-6 w-6', colors.value.text]),
                                  "aria-hidden": "true"
                                }, null, 8, ["class"])
                              ], 2),
                              _createElementVNode("div", _hoisted_5, [
                                _createVNode(_unref(DialogTitle), {
                                  as: "h3",
                                  class: "text-lg font-medium leading-6 text-gray-900"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(confirmationModalArgsWithDelayedClear.value.header), 1)
                                  ]),
                                  _: 1
                                }),
                                (confirmationModalArgsWithDelayedClear.value.message)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                      _createElementVNode("p", _hoisted_7, _toDisplayString(confirmationModalArgsWithDelayedClear.value.message), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("button", {
                                type: "button",
                                class: _normalizeClass([
                      'inline-flex w-full justify-center rounded-md border border-transparent px-4 py-2 text-base font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm',
                      colors.value.bgMedium,
                      colors.value.bgHover,
                      colors.value.ringFocus,
                    ]),
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (setConfirm(true)))
                              }, _toDisplayString(confirmationModalArgsWithDelayedClear.value.confirmAction), 3),
                              _createElementVNode("button", {
                                type: "button",
                                class: "mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:mt-0 sm:w-auto sm:text-sm",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (setConfirm(false)))
                              }, _toDisplayString(confirmationModalArgsWithDelayedClear.value.cancelAction), 1)
                            ])
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})